'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of alert mobile
 */ const AlertMobile = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M104 52C104 80.7188 80.7188 104 52 104C23.2812 104 0 80.7188 0 52C0 23.2812 23.2812 0 52 0C80.7188 0 104 23.2812 104 52Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "43.0234",
                y: "68.7812",
                width: "17.5976",
                height: "5.18509",
                rx: "1.61817",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M40.516 19H63.012C64.6463 19.009 66.2108 19.658 67.3648 20.8059C68.5188 21.9537 69.1689 23.5072 69.1734 25.1282V78.5885C69.1688 80.2125 68.5164 81.7686 67.3587 82.9169C66.201 84.0652 64.6321 84.7123 62.9948 84.7168H40.4989C38.8616 84.7123 37.2927 84.0652 36.135 82.9169C34.9772 81.7686 34.3248 80.2125 34.3203 78.5885V66.83V59.2622V57.4036V25.1282C34.3249 23.5014 34.9796 21.9427 36.1411 20.7939C37.3025 19.6451 38.8758 19 40.516 19Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M58.3838 68.8691H45.1428C43.7328 68.8691 42.5898 70.0028 42.5898 71.4013C42.5898 72.7998 43.7328 73.9334 45.1428 73.9334H58.3838C59.7937 73.9334 60.9367 72.7998 60.9367 71.4013C60.9367 70.0028 59.7937 68.8691 58.3838 68.8691Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "48.8438",
                y: "73.9102",
                width: "6.04773",
                height: "5.86592",
                rx: "2.93296",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "37.0156",
                y: "21.916",
                width: "29.7011",
                height: "48.5272",
                rx: "1.98447",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "68.8062",
                cy: "31.1988",
                r: "16.8062",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M53.8438 48.6618L56.0846 40.8848L60.6322 45.0369L53.8438 48.6618Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M56.0362 43.482L56.7307 41.0581L55.8047 39.6947L57.1866 38.9316L61.8829 43.8046L61.6889 45.0098L60.525 44.3632L58.2618 45.5918L56.0362 43.482Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "65.8906",
                y: "19.1621",
                width: "5.22248",
                height: "17.894",
                rx: "2.61124",
                transform: "rotate(-0.171913 65.8906 19.1621)",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "68.5278",
                cy: "40.9066",
                r: "2.62934",
                transform: "rotate(-0.171913 68.5278 40.9066)",
                fill: theme.ds5.asset[assetColor]["600"]
            })
        ]
    });
};

exports.AlertMobile = AlertMobile;
//# sourceMappingURL=AlertMobile.cjs.map
